import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { getConfiguration, isDebug } from './components/Util/ConfigHelper';
import { DeploymentType } from './components/Data/Models/configuration';
import { BrowserRouter } from 'react-router-dom';
import ScormProvider, { withScorm } from "react-scorm-provider";
import { PostHogProvider } from 'posthog-js/react'

const options = {
    api_host: 'https://eu.i.posthog.com',
    defaults: '2025-05-24',
}

const root = ReactDOM.createRoot(document.getElementById('root'));
if (getConfiguration().deploymentType === DeploymentType.Web) {
   root.render(
       <PostHogProvider apiKey={'phc_NtKBOQRL9qZFbwayHtGW1Z6HuUYf5FoJoZbuCU2ci22'} options={options}>
          <BrowserRouter>
          <App />
          </BrowserRouter>
       </PostHogProvider>
   );
} else if (getConfiguration().deploymentType === DeploymentType.Scorm) {

    const ScormApp = withScorm()(App);
    root.render(
        <ScormProvider debug={isDebug()}>
            <ScormApp />
        </ScormProvider>
    );
} else {
    root.render(
       <PostHogProvider apiKey={'phc_NtKBOQRL9qZFbwayHtGW1Z6HuUYf5FoJoZbuCU2ci22'} options={options}>
          <App />
       </PostHogProvider>
   );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
